<template>
  <div>
    <!--轮播图-->
    <div class="w100 cpfa">
      <div class="flexslider">
        <ul class="slides">
          <div class="lunBotu">
            <div class="container">
              <div class="ban2 float">
                <h2>产品体验</h2>
                <p>Product Experience</p>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </div>

    <!-- 主体内容 -->
    <formContent class="formcontent"></formContent>

    <!-- 产品体验 -->
    <productBanner :Product="product" class="bannerFather"></productBanner>

    <div class="foooter">
      <cooperateForm class="submitform" id="submit"></cooperateForm>
    </div>
  </div>
</template>

<script>
import cooperateForm from './cooperate'
import formContent from './formContent'
import productBanner from './banner'

export default {
  data () {
    return {
      product: {
        'background': 'images/coretesc/banner_2.png',
        // 'desc': '—音频处理专家',
        'h2': '语音降噪与增强体验'
        // 'product': 'images/experience/sb_rs.png'
      }
    }
  },
  methods: {
    getWeb () {
      let userAgent = navigator.userAgent
      if ((userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0')) || ((userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1))) {
        this.wavUrl = this.theUrl
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    const params = this.$route.params
    if (params.hasOwnProperty('ScorldId')) {
      if (this.getWeb()) {
        document.documentElement.scrollTop = 1850
      } else {
        document.getElementById(params['ScorldId']).scrollIntoView()
      }
    }
  },
  components: {
    cooperateForm: cooperateForm,
    formContent: formContent,
    productBanner
  }
}
</script>

<style scoped>
.flexslider {
  position: relative;
  height: 584px;
  overflow: hidden;
  z-index: 1;
  clear: both;
  margin-top: -65px;
}
.cpfa .container {
  padding-top: 215px;
}
.cpfa .container .float {
  width: 100%;
  /* margin-top: 71px; */
  margin: 0 auto;
}
.cpfa .ban2 h2 {
  text-align: center;
  margin-bottom: 15px;
  font-size: 40px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
}
.lunBotu {
  margin-top: 4px;
  background: url(../../../assets/images/experience/tyzx_banner.png) no-repeat;
  z-index: 1;
  background-size: 100% 100%;
  height: 587px;
}
.container p {
  font-size: 30px;
  font-weight: normal;
  color: rgba(255, 255, 255, 1);
  opacity: 0.5;
}
/* 产品体验 */
.product :first-child {
  width: 100%;
  background-size: 100% 100%;
  height: 399px;
}
.form {
  margin-top: 62px;
}
.footerup {
  height: 19px;
  margin-top: -258px;
  margin-bottom: 160px;
}
.foooter {
  background: white;
}
.formcontent {
  height: 1100px;
}
.submitform {
  width: 803px;
  margin-top: -55px;
  margin-bottom: -23px;
}
.footblack {
  height: 50px;
  width: 100%;
  background: rgba(248, 248, 248, 1);
}
</style>

<style >
.el-message {
  min-width: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/form/experienceCenter.vue